
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "16",
    "height": "13",
    "viewBox": "0 0 16 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M8.18803 10.7847H0.815335C0.706839 10.7841 0.599322 10.8053 0.499154 10.847C0.398986 10.8887 0.308207 10.95 0.232195 11.0275C0.156183 11.1049 0.0964867 11.1968 0.0566424 11.2977C0.0167981 11.3986 -0.00238284 11.5065 0.000236241 11.615C0.000236241 12.1332 0.306009 12.4443 0.815335 12.4443H8.18803C8.59514 12.4443 9.00313 12.1332 9.00313 11.615C9.00313 11.0958 8.69736 10.7847 8.18803 10.7847ZM0.815335 7.05146H15.1849C15.6942 7.05146 16 6.63725 16 6.22214C16 5.80704 15.6942 5.39282 15.1849 5.39282H0.815335C0.706916 5.3922 0.599473 5.41333 0.499366 5.45497C0.399258 5.4966 0.30852 5.5579 0.23252 5.63522C0.156521 5.71255 0.0968051 5.80433 0.0569066 5.90515C0.0170082 6.00596 -0.00226209 6.11375 0.000236241 6.22214C0.102457 6.63725 0.40823 7.05146 0.815335 7.05146ZM0.815335 1.55555H15.1849C15.592 1.55555 16 1.24444 16 0.726225C16 0.207121 15.6942 1.33931e-05 15.1849 1.33931e-05H0.815335C0.706916 -0.000609809 0.599473 0.0205219 0.499366 0.0621581C0.399258 0.103794 0.30852 0.165089 0.23252 0.242414C0.156521 0.319739 0.0968051 0.411524 0.0569066 0.512337C0.0170082 0.61315 -0.00226209 0.720942 0.000236241 0.829334C0.000236241 1.34844 0.40823 1.55555 0.815335 1.55555Z",
        "fill": "#333333"
      }
    }
  ]
})
    }
  